import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const BlogEdit = () => {

  const [careerId, setCareerId] = useState("");
  const [careers, setCareers] = useState([]);
  const [title, setTitle] = useState("");
  const [language, setLanguage] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const [existingPdf, setExistingPdf] = useState("");

  const navigate = useNavigate();
  const { blogId } = useParams();

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;


  useEffect(() => {

    fetchAllCareers();
    fetchBlogDetails();

  }, [blogId]);



  /* FETCH CAREERS */
  const fetchAllCareers = async () => {

    try {

      const response = await axios.get(`${API_BASE_URL}/careerCategories`);

      setCareers(response.data?.data || []);

    }
    catch (error) {

      console.error(error);

    }

  };



  /* FETCH BLOG DETAILS */
  const fetchBlogDetails = async () => {

    try {

      const response = await axios.get(`${API_BASE_URL}/blogs/${blogId}`);

      const blog = response.data.data;

      setCareerId(blog.careerId._id);
      setTitle(blog.title);
      setLanguage(blog.language);
      setExistingPdf(blog.pdfFile);

    }
    catch (error) {

      console.error(error);
      alert("Failed to fetch blog");

    }

  };



  /* FILE CHANGE */
  const handleFileChange = (e) => {

    setPdfFile(e.target.files[0]);

  };



  /* SUBMIT UPDATE */
  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!careerId || !title || !language) {

      alert("All fields required");
      return;

    }

    try {

      const formData = new FormData();

      formData.append("careerId", careerId);
      formData.append("title", title);
      formData.append("language", language);

      if (pdfFile) {
        formData.append("pdfFile", pdfFile);
      }

      const role = localStorage.getItem("role");
      const endpoint =
        role === "subAdmin"
          ? `${API_BASE_URL}/subadmin/blogs/${blogId}`
          : `${API_BASE_URL}/admin/blogs,${blogId}`;

      const response = await axios.put(

        // `${API_BASE_URL}/admin/blogs/${blogId}`,
        endpoint,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }

      );


      if (response.status === 200) {

        alert("Blog updated successfully");
        navigate("/all-blog");

      }

    }
    catch (error) {

      console.error(error);
      alert("Update failed");

    }

  };



  return (

    <div className="blogAddContainer">

      <div className="blogAddHeader">

        <h5>Edit Blog</h5>

      </div>



      <div className="blogAddFormContainer">

        <form className="blogAddForm" onSubmit={handleSubmit}>



          {/* Career */}
          <div className="blogAddInputGroup">

            <label>Select Career</label>

            <select
              value={careerId}
              onChange={(e) => setCareerId(e.target.value)}
              required
            >

              <option value="">-Select Career-</option>

              {careers.map((career) => (

                <option key={career._id} value={career._id}>
                  {career.name}
                </option>

              ))}

            </select>

          </div>



          {/* Title */}
          <div className="blogAddInputGroup">

            <label>Title</label>

            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />

          </div>



          {/* Language */}
          <div className="blogAddInputGroup">

            <label>Language</label>

            <select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              required
            >

              <option value="">-Select Language-</option>
              <option value="english">English</option>
              <option value="hindi">Hindi</option>

            </select>

          </div>



          {/* Existing PDF */}
          {existingPdf && (

            <div className="blogAddInputGroup">

              <label>Current PDF:</label>

              <a
                href={`${API_BASE_URL}/uploads/${existingPdf}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                View PDF
              </a>

            </div>

          )}



          {/* Upload new PDF */}
          <div className="blogAddInputGroup">

            <label>Upload New PDF (optional)</label>

            <input
              type="file"
              accept="application/pdf"
              onChange={handleFileChange}
            />

          </div>



          {/* Submit */}
          <div className="blogAddButtonGroup">

            <button type="submit" className="blogAddSaveButton">

              Update Blog

            </button>

          </div>


        </form>

      </div>

    </div>

  );

};

export default BlogEdit;
